// extracted by mini-css-extract-plugin
export default {"form":"ReactForm_form__jpHfn"};